import React from "react";
import Sidebar from "./Sidebar";
import AdminNavbar from "./Navbar";
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <div className="roha-admin-shell">
      <Sidebar />
      <div className="roha-admin-shell__content">
        <AdminNavbar />
        <main className="roha-admin-shell__main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
